import I18n from 'I18n';
import { RENAMING_ERRORS, INVALID_SYMBOLS } from '../constants/campaignName';
import { HTTP_STATUS_CODES } from '../constants/httpStatusCode';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getMarketingRootUrl } from './urls';
import { UsageTracker } from './usageTracker';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const VALIDATION_KEYS = ['INVALID_NAME_RE', 'LEADING_WHITESPACE_RE', 'TRAILING_WHITESPACE_RE', 'DOUBLE_WHITESPACE_RE'];
const REGEX_MAP = {
  INVALID_NAME_RE: new RegExp(`[${INVALID_SYMBOLS.join('')}]`),
  LEADING_WHITESPACE_RE: new RegExp(/^\s/),
  TRAILING_WHITESPACE_RE: new RegExp(/\s$/),
  DOUBLE_WHITESPACE_RE: new RegExp(/\s\s/)
};
export const DEFAULT_MESSAGES_MAP = {
  INVALID_NAME_RE: {
    message: `campaignsLib.createForm.fields.displayName.error.invalidSymbols`,
    options: {
      invalidSymbols: INVALID_SYMBOLS.join(' ')
    }
  },
  LEADING_WHITESPACE_RE: {
    message: `campaignsLib.createForm.fields.displayName.error.leadingWhitespace`
  },
  TRAILING_WHITESPACE_RE: {
    message: `campaignsLib.createForm.fields.displayName.error.trailingWhitespace`
  },
  DOUBLE_WHITESPACE_RE: {
    message: `campaignsLib.createForm.fields.displayName.error.doubleWhitespace`
  }
};
export const EXISTING_NAME_MESSAGE = 'Campaign with this name already exists';
export const EXISTING_UTM_MESSAGE = 'Campaign with this utm already exists';
export const getCampaignRenamingErrorType = error => {
  switch (error.status) {
    case HTTP_STATUS_CODES.CONFLICT:
      switch (error.responseJSON && error.responseJSON.message) {
        case EXISTING_NAME_MESSAGE:
          return RENAMING_ERRORS.EXISTING_NAME;
        case EXISTING_UTM_MESSAGE:
          {
            var _error$responseJSON;
            const errorTokens = (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorTokens;
            if (((errorTokens === null || errorTokens === void 0 ? void 0 : errorTokens.conflictingCampaignGuid) || []).length > 0 && ((errorTokens === null || errorTokens === void 0 ? void 0 : errorTokens.campaignUtm) || []).length > 0 && ((errorTokens === null || errorTokens === void 0 ? void 0 : errorTokens.conflictingCampaignName) || []).length > 0) {
              return RENAMING_ERRORS.EDITABLE_EXISTING_UTM;
            }
            return RENAMING_ERRORS.EXISTING_UTM;
          }
        default:
          return RENAMING_ERRORS.GENERIC;
      }
    default:
      return RENAMING_ERRORS.GENERIC;
  }
};
export const getIsCampaignNameValid = name => !REGEX_MAP.INVALID_NAME_RE.test(name || '');
export const getCampaignNameValidationError = (name = '', customValidationMessages) => {
  const validationMessages = customValidationMessages || DEFAULT_MESSAGES_MAP;
  for (const key in validationMessages) {
    if (Object.hasOwn(validationMessages, key)) {
      const validationKey = VALIDATION_KEYS.find(k => k === key);
      if (validationKey) {
        const regEx = REGEX_MAP[validationKey];
        if (regEx.test(name)) {
          return validationMessages[validationKey];
        }
      }
    }
  }
  return null;
};
export const getMessageFromAPIError = error => {
  // Convert errors from creating, updating or cloning a campaign into a useful
  // error message. Errors may relate to either the display name or UTM fields.
  switch (error.status) {
    case HTTP_STATUS_CODES.NOT_ACCEPTABLE:
      return I18n.text('campaignsLib.errors.invalidCharacters.message');
    case HTTP_STATUS_CODES.CONFLICT:
      {
        const errorType = getCampaignRenamingErrorType(error);
        if (errorType === RENAMING_ERRORS.EDITABLE_EXISTING_UTM) {
          var _error$responseJSON2, _errorTokens$conflict, _errorTokens$conflict2;
          UsageTracker.track('campaignsCreate', {
            action: 'conflicting utm',
            screen: 'campaign'
          });
          const errorTokens = (_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : _error$responseJSON2.errorTokens;
          const campaignName = errorTokens === null || errorTokens === void 0 || (_errorTokens$conflict = errorTokens.conflictingCampaignName) === null || _errorTokens$conflict === void 0 ? void 0 : _errorTokens$conflict[0];
          const conflictingCampaignGuid = errorTokens === null || errorTokens === void 0 || (_errorTokens$conflict2 = errorTokens.conflictingCampaignGuid) === null || _errorTokens$conflict2 === void 0 ? void 0 : _errorTokens$conflict2[0];
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "campaignsLib.errors.editableExistingUTM.message_jsx",
            options: {
              existingCampaignName: campaignName,
              href: `${getMarketingRootUrl()}/campaigns/${conflictingCampaignGuid}`
            },
            elements: {
              Link,
              strong: 'strong'
            }
          });
        }
        return I18n.text(`campaignsLib.errors.${errorType}.message`);
      }
    default:
      return error.responseJSON && error.responseJSON.message || '';
  }
};